import { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./Button.module.css";

type Variant = "primary" | "secondary" | "quiet" | "glass";

interface CommonProps {
  variant?: Variant;
  size?: "md" | "lg";
  icon?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export type ButtonAsButton = CommonProps &
  ButtonHTMLAttributes<HTMLButtonElement> & { to?: undefined };
export type ButtonAsLink = CommonProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { to: string };

export default function Button(props: ButtonAsButton | ButtonAsLink) {
  const { variant = "primary", size = "md", icon, className, children } = props;
  const cls = [styles.button, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(" ");

  if (props.to !== undefined) {
    const { variant: _v, size: _s, icon: _i, className: _c, children: _ch, to, ...anchor } =
      props as ButtonAsLink;
    return (
      <Link to={to} className={cls} {...anchor}>
        {icon}
        {children}
      </Link>
    );
  }

  const { variant: _v, size: _s, icon: _i, className: _c, children: _ch, to: _t, type, ...button } =
    props as ButtonAsButton;
  return (
    <button type={type ?? "button"} className={cls} {...button}>
      {icon}
      {children}
    </button>
  );
}
